<div class="app-wrapper" [attr.isAuthPage]="isAuthPage">
  <router-outlet></router-outlet>
  <div class="versions-wrapper">
    <p *ngIf="isAuthPage" class="version-text">{{showBothVersions ? 'UI - ' + 'V' + version : 'V' + version}}</p>
    <p *ngIf="isAuthPage && showBothVersions" class="version-text">{{'API - ' + 'V' + versionFromBack}}</p>
  </div>
</div>
<app-notification></app-notification>
